export function PrivacyPage() {
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-fg">Privacy Policy</h1>
        <p className="mt-1 text-sm text-fg-2">
          How Bhandari Photos handles your photos and data.
        </p>
      </div>

      <div className="space-y-5 text-sm leading-relaxed text-fg-2">
        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">What we store</h2>
          <p>
            Bhandari Photos stores the photos and videos you upload, along with
            the metadata embedded in them (such as capture date and, where
            present, location). This media is kept so it can be displayed back
            to you across the gallery, timeline, and map views.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">How your media is used</h2>
          <p>
            Your media is used only to provide the gallery experience. We do not
            sell your photos or metadata, and we do not use them for advertising
            or to train third-party services.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">Location data</h2>
          <p>
            Some photos carry GPS coordinates in their metadata. When present,
            this location is used solely to plot photos on the Map view. You can
            remove location data from photos before uploading if you prefer not
            to share it.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">Data retention &amp; deletion</h2>
          <p>
            Uploaded media is retained until you delete it. Deleting a photo
            removes it from storage and it will no longer appear in any view.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">Contact</h2>
          <p>
            For any privacy questions or requests, please reach out to the site
            owner.
          </p>
        </section>
      </div>
    </div>
  );
}
